import type { TConfirmCandidateSource } from '~/domain/ConfirmCandidateSource';
import PosthogService from '~/services/posthog/PosthogService';
import { toCandidatePositionProperties, type IConfirmCandidatePositionContext } from './types';

export interface IConfirmCandidateConfirmClickedPayload extends IConfirmCandidatePositionContext {
  /**
   * How the office reached this screen (GOTU-4906) — the link between a
   * confirmation and the notification or list that drove it. Undefined, and so
   * absent from the event, when the office arrived by a path we don't attribute.
   */
  source?: TConfirmCandidateSource;
}

/**
 * Fires when an office clicks the "Confirm" button on the Confirm Candidate page.
 *
 * Note this fires *before* the confirm request is sent, so it counts attempts that
 * later fail (a missing payment card, a server error) as well as shifts that were
 * actually filled.
 *
 * Event: dental_portal:confirm_candidate:confirm_clicked
 */
export function fireConfirmCandidateConfirmClicked(
  payload: IConfirmCandidateConfirmClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:confirm_candidate:confirm_clicked', {
    ...toCandidatePositionProperties(payload),
    source: payload.source,
  });
}
